module.exports = __webpack_public_path__ + "static/img/02.c25a8e7a.png";